var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"grey lighten-4"}},[_c('v-toolbar',{attrs:{"height":"100px"}},[_c('v-row',[_c('v-col',[_c('img',{staticClass:"imageSize",attrs:{"src":require("../../assets/gfi.png")}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }